import axios from "axios";

export interface ICexApi {
  fetchKLines: (exchange: string, symbol: string, interval: string, startTime: number, endTime: number, limit: number) => Promise<any>;
  fetchLastKLine: (exchange: string, symbol: string, interval: string) => Promise<any>;
  fetchHuobiKlines: (exchange: string, symbol: string, interval: string, limit: number) => Promise<any>;
  fetchGateIoCandles: (params: any) => Promise<any>;
  fetchHitbtcLastCandle: (symbol: string, interval: string) => Promise<any>;
}

export class CexApi implements ICexApi {
  public apiGateway: string
  constructor(apiGateway: string) {
    if (!apiGateway) {
      this.apiGateway = 'https://api.kattana.trade';
    } else {
      this.apiGateway = apiGateway
    }
  }


  /**
   * get Klines from binance or hitbtc
   */
  public fetchKLines = async (exchange: string, symbol: string, interval: string, startTime: number, endTime: number, limit: number) => {
    try {
      const payload = {
        symbol,
        interval,
        startTime,
        endTime,
        limit,
      };
      const { data } = await axios(
        `${this.apiGateway}/cex_charts/${exchange}/chart/${JSON.stringify(payload)}`
      );
  
      return data;
    } catch (err) {
      console.warn(err);
      return [];
    }
  }

  /**
  * Get klines without starttime or end time
  */
  public fetchHuobiKlines = async (exchange: string, symbol: string, interval: string, limit: number) => {
    try {
      const payload = {
        symbol,
        interval,
        limit,
      };
      const { data } = await axios(
        `${this.apiGateway}/cex_charts/${exchange}/chart/${JSON.stringify(payload)}`
      );

      return data;
    } catch (err) {
      console.warn(err);
      return [];
    }
  }

  /**
   * gets candles depending on params (can get last one, all etc)
   */
  public fetchGateIoCandles = async (params: any) => {
    try {
      const { data } = await axios.get(
        `${this.apiGateway}/cex_charts/gateio/chart/${JSON.stringify(params)}`
      );

      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };
  
  /**
   *
   * @param sym
   * @param interval
   * @returns
   */
  public fetchHitbtcLastCandle = async (symbol: string, interval: string) => {
    try {
      const { data } = await axios(
        `${this.apiGateway}/cex_charts/hitbtc/candle/${JSON.stringify({
          symbol,
          interval,
        })}`
      );
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  };


  /**
   * Fetch last candle
   * @param exchange
   * @param symbol
   * @param interval
   * @returns
   */
  public fetchLastKLine = async (exchange: string, symbol: string, interval: string) => {
    try {
      const payload = {
        symbol,
        interval,
      };
      const url = `${this.apiGateway}/cex_charts/${exchange}/candle/${JSON.stringify(
        payload
      )}`;
      const { data } = await axios(url);

      return data;
    } catch (err) {
      console.warn(err);
      return [];
    }
  }
}
